
import {of as observableOf, of,  Observable } from 'rxjs';

import {catchError, switchMap} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { UserService } from '../services/user.service';
import { Alert, AlertType } from '../../shared/alert.model';
import { User } from '../models/user.model';
import { getAlertMessage } from '../../shared/api-loaders';

@Injectable()
export class UserDetailResolver  {

  constructor(
    private userService: UserService,
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    const context: {
      id?: string,
      alert?: Alert,
      user?: User,
    } = {};

    const requestUserId = route.paramMap.get('id');
    context.id = requestUserId;

    return of(context);

    // I don't see any value in having this so i commented out. We are anyway calling getUser in user detail page.
    /*return this.userService
      .getUser(context.id).pipe(
      switchMap((user: User) => {
        context.user = user;
        return observableOf(context);
      }),
      catchError(err => {
        console.error(`Error occurred while retrieving user information: ${err}`);
        if (err && err.status === 404 && err.code === 'SSOResourceNotFoundException' && !context.user) {
          context.alert = new Alert(AlertType.DANGER, `Requested user ${context.id} does not exist in the system.`);
        } else {
          context.alert = getAlertMessage(err);
        }
        return observableOf(context);
      }),);*/
  }
}
